import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FaSearch } from "react-icons/fa";
import OrderApi from "../apis/order.apis";
import { useEffect } from "react";
import { useFetchAll } from "../custom/FetchApiHook";
import DispatchOrderCard from "../pages/Order/Dispatch/DispatchOrderCard";
import { DeliveryManApis } from "../apis/delivery.apis";


const DispatchRightSideComponent = ({setPagination,values}) => {
  const dispatchOrders = values?.data?.orders || [];
  const { theme } = useSelector((state) => state.theme);
  const [searchQuery, setSearchQuery] = useState("");
const [allDeliveryMan,setAllDeliveryMan]=useState("")
console.log("values:",dispatchOrders);

 const fetchAllDeliveryMan = async () => {
  try {
    const payload = {
      filter: { "availability.status": "available" },
      page: 1,
      limit: 100,
      sortOrder: "desc"
    };

    const res = await DeliveryManApis.getAllDeliveryMan(payload);
    setAllDeliveryMan(res?.data?.data || []);
  } catch (error) {
    console.log("error:", error);
  }
};

  console.log("all Delivery Man",allDeliveryMan);

  const [leftTabs, setLeftTabs] = useState([
    {
      tab: "New",
      isActive: true,
    },
    {
      tab: "Assigned",
      isActive: false,
    },
    {
      tab: "On Delivery",
      isActive: false,
    },
  ]);

  const data = [
    { id: 1, status: "New" },
    { id: 2, status: "Assigned" },
    { id: 3, status: "On Delivery" },
  ];

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = data.filter((item) => {
    return Object.values(item).some(
      (objValue) =>
        objValue !== null &&
        objValue
          .toString()
          .toLowerCase()
          .includes(searchQuery.trim().toLowerCase())
    );
  });

  const handleSwitch = (t, i) => {
    {t.tab==="Assigned" && setPagination({
      "page": 1,
        "limit": 5,
        "sortOrder": "desc",
        "filter": {"orderDetails.delivery_status": "AWAITDELIVERYMAN"}

    })}
    {t.tab==="New" && setPagination({
      "page": 1,
        "limit": 5,
        "sortOrder": "desc",
        "filter": {
          "orderDetails.delivery_status": "ASSIGNED"
        }
    })}
    const updatedTabs = leftTabs.map((item, index) => {
      if (index === i) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    setLeftTabs(updatedTabs);
  };

  const activeTab = leftTabs.find((tab) => tab.isActive);

  //order api
  

  const displayedData = activeTab
    ? filteredData.filter((item) => item.status === activeTab.tab)
    : filteredData;

     useEffect(()=>{
      fetchAllDeliveryMan();
      },[])
  
  return (
    <div
      className={`${
        theme === "light" ? "bg-secondaryColor" : "bg-darkThirsary"
      } shadow-2xl px-3 w-1/4 hidden lg:block`}
    >
      <ul className="flex justify-between text-sm cursor-pointer">
        {leftTabs.map((item, i) => (
          <li
            key={i}
            className={`${
              item.isActive ? "border-t-4  border-buttonColor" : ""
            }  w-full text-center py-3`}
            onClick={() => handleSwitch(item, i)}
          >
            {item.tab}
          </li>
        ))}
      </ul>
      <div className="border border-[--color--1] rounded-full px-3 my-4 py-1.5 text-xs bg-transparent w-full flex justify-between items-center">
        <input
          type="search"
          placeholder="search..."
          value={searchQuery}
          onChange={handleSearch}
          className="bg-transparent outline-none w-full "
        />
        <FaSearch className="text-[--color--1]" />
      </div>
      <div className="mt-4">
        {displayedData[0].status==="New" && dispatchOrders.length> 0 ? dispatchOrders.map((item) => (
          <div key={item.id} className="text-sm p-2 mb-2">
            <DispatchOrderCard item={item} allDeliveryMan={allDeliveryMan} fetchAllDeliveryMan={fetchAllDeliveryMan}/>
          </div>
        )): (
          <div>
            <p>No Order Available</p>
          </div>
        )}
        {displayedData[0].status==="Assigned" && dispatchOrders.map((item) => (
          <div key={item.id} className="text-sm p-2 mb-2">
            <DispatchOrderCard item={item} allDeliveryMan={allDeliveryMan} fetchAllDeliveryMan={fetchAllDeliveryMan}/>
          </div>
        ))}
        
      </div>
    </div>
    
  );
};

export default DispatchRightSideComponent;
